// Billing application
export const FETCH_BILLING = "/payments/";

// Billing download
export const DOWNLOAD_BILLING = "/payments/download/";
